import React, { Component } from 'react';
import AdminLayout from './AdminLayout.jsx';
import { fetchDataFile } from '../../APICall/Api.jsx';

const CONTENT_TYPES = [
  { label: 'News Articles',  file: 'newsEng.json',        key: 'news',         color: '#2e7d32', icon: 'fas fa-newspaper' },
  { label: 'Projects',       file: 'ProjectsEng.json',    key: 'projects',     color: '#1976d2', icon: 'fas fa-project-diagram' },
  { label: 'Trainings',      file: 'TrainingsEng.json',   key: 'trainings',    color: '#f57c00', icon: 'fas fa-chalkboard-teacher' },
  { label: 'Events',         file: 'EventsEng.json',      key: 'events',       color: '#d32f2f', icon: 'fas fa-calendar-alt' },
  { label: 'Services',       file: 'ServicesEng.json',    key: 'services',     color: '#7b1fa2', icon: 'fas fa-cogs' },
  { label: 'Publications',   file: 'PublicationsEng.json',key: 'publications', color: '#0288d1', icon: 'fas fa-file-pdf' },
  { label: 'Staff Members',  file: 'StaffEng.json',       key: 'staff',        color: '#388e3c', icon: 'fas fa-users' },
  { label: 'Sponsors',       file: 'Sponsors.json',       key: 'sponsors',     color: '#455a64', icon: 'fas fa-handshake' },
];

class AdminDashboard extends Component {
  state = { counts: {}, loading: true };

  async componentDidMount() {
    const counts = {};
    await Promise.all(
      CONTENT_TYPES.map(async (ct) => {
        try {
          const data = await fetchDataFile(ct.file);
          const arr = data[ct.key];
          if (Array.isArray(arr)) {
            counts[ct.key] = arr.length;
          } else if (arr && arr.elements) {
            counts[ct.key] = arr.elements.length;
          } else if (arr && arr.list) {
            counts[ct.key] = arr.list.length;
          } else {
            counts[ct.key] = '?';
          }
        } catch (e) {
          counts[ct.key] = '–';
        }
      }),
    );
    this.setState({ counts, loading: false });
  }

  render() {
    const { counts, loading } = this.state;
    const { history, location } = this.props;

    return (
      <AdminLayout title="Dashboard" history={history} location={location}>
        <p style={{ color: '#8a8aaa', marginBottom: 28, fontSize: '0.92rem' }}>
          Welcome back. Here's an overview of your content.
        </p>

        {/* Stat cards */}
        <div className="bgg-admin-stats">
          {CONTENT_TYPES.map((ct) => (
            <div
              key={ct.key}
              className="bgg-admin-stat"
              style={{ borderTopColor: ct.color, cursor: 'pointer' }}
              onClick={() => history.push(`/admin/${ct.key === 'staff' ? 'staff' : ct.key}`)}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                <i className={ct.icon} style={{ color: ct.color, fontSize: 22 }} />
              </div>
              <div className="bgg-admin-stat-num" style={{ color: ct.color }}>
                {loading ? '…' : counts[ct.key]}
              </div>
              <div className="bgg-admin-stat-label">{ct.label}</div>
            </div>
          ))}
        </div>

        {/* Quick links */}
        <div className="bgg-admin-card">
          <div className="bgg-admin-card-header">
            <h2>Quick Actions</h2>
          </div>
          <div style={{ padding: '20px 24px', display: 'flex', flexWrap: 'wrap', gap: 12 }}>
            {CONTENT_TYPES.map((ct) => (
              <button
                key={ct.key}
                className="bgg-btn bgg-btn-outline bgg-btn-sm"
                onClick={() => history.push(`/admin/${ct.key === 'staff' ? 'staff' : ct.key}`)}
              >
                <i className={ct.icon} /> Manage {ct.label}
              </button>
            ))}
          </div>
        </div>
      </AdminLayout>
    );
  }
}

export default AdminDashboard;



// WEBPACK FOOTER //
// ./src/views/Admin/AdminDashboard.jsx